import { useSite } from "@/context/SiteContext";

const Marquee = () => {
  const { content } = useSite();
  const text = content.marquee || "";
  return (
    <div className="overflow-hidden border-y border-[#1A1713]/10 bg-[#F5F2EA] py-6" data-testid="editorial-marquee">
      <div className="marquee-track flex w-max whitespace-nowrap">
        {[0, 1].map((n) => (
          <span
            key={n}
            aria-hidden={n === 1}
            className="pr-8 font-serif text-2xl italic text-[#1A1713]/70 md:text-3xl"
          >
            {text.repeat(4)}
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
